import { Loading } from 'components';
import GeneralHeader from 'components/common/GeneralHeader';
import AdminInfo from 'components/form/personal_data/admin/admin';
import CivilStatus from 'components/form/personal_data/civil_status/civil_status';
import PersonalInfo from 'components/form/personal_data/personalData/personal_data';
import Rules from 'components/form/personal_data/rules/rules';
import StaffInfo from 'components/form/personal_data/staffing/staffing';
import TehnicalInfo from 'components/form/personal_data/tehnical_info/tehnical_info';
import WorkingDays from 'components/form/personal_data/working_days/working_days';
import { useFormik } from 'formik';
import useAuth from 'hooks/useAuth';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { PUT, personalData } from 'utils';
import {
  getCountries,
  getNationality,
} from 'utils/common_function/get_country_and_cities';
import { dataKeyUser } from 'utils/mockData';
import * as Yup from 'yup';
import {
  lengthRegex,
  lowercaseRegex,
  numberRegex,
  uppercaseRegex,
} from 'utils/regex/regexPassword';

const formSchema = Yup.object().shape({
  last_name: Yup.string().required('Last name is required'),
  first_name: Yup.string().required('First name is required'),
  job_title: Yup.string().required('Job title is required'),
  social_security_number: Yup.string().required(
    'Social Security Number is required',
  ),
  birth_name: Yup.string().required('Birth Name is required'),
  birth_city: Yup.string().required('City of Birth is required'),
  personal_email: Yup.string().nullable().email('Personal Email is invalid'),
});
const listOptionsPersonal = [
  {
    name: 'Personal Data',
    value: 0,
  },
  {
    name: 'Staffing',
    value: 1,
  },
  {
    name: 'Rules',
    value: 2,
  },
  {
    name: 'Admin',
    value: 3,
  },
  // {
  //   name: 'Preference',
  //   value: 4,
  // },
];

const PersonalData = () => {
  const { slug, user_id } = useParams();
  const { getUserById } = useMember();
  const { user } = useAuth();
  const { error, successNotification } = useNotice();
  const [updateData, setUpdateData] = useState({});
  const [numberTab, setNumberTab] = useState<number>(0);
  const [widthTransition, setWidthTransition] = useState<number>(0);
  const [state, setState] = useState({
    countries: [{ label: '', value: '' }],
    nationality: [{ label: '', value: '' }],
    userData: {} as personalData,
    loading: true,
  });

  const { countries, nationality, loading } = state;

  const containerRef = useRef<HTMLDivElement>(null);
  const ItemWidth = containerRef.current?.children[numberTab].clientWidth;

  function getPersonalData() {
    return getUserById(`${slug || user_id}/`);
  }
  const { data, status, refetch } = useQuery(
    'get-personal-data',
    getPersonalData,
    {
      refetchOnWindowFocus: false,
    },
  );

  const formik = useFormik({
    initialValues: {
      last_name: '',
      first_name: '',
      department__name: '',
      email: '',
      title: '',
      job_title: '',
      facebook: '',
      twitter: '',
      viavideo: '',
      linkedin: '',
      personal_email: '',
    },
    validationSchema: data?.data?.role !== 'admin' && formSchema,
    validateOnChange: false,
    onSubmit: (data) => {
      submit(data);
    },
  });
  function removeNullFields(obj) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
      if (obj[key] !== null) {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }

  const submit = async (data: any) => {
    const finalData = data;
    const password =
      finalData?.password === '' ? undefined : finalData?.password;
    const confirm_password =
      finalData?.confirm_password === ''
        ? undefined
        : finalData?.confirm_password;
    const hasLength = lengthRegex.test(password);
    const hasLowercase = lowercaseRegex.test(password);
    const hasUppercase = uppercaseRegex.test(password);
    const hasNumber = numberRegex.test(password);
    setState((pre) => ({ ...pre, loading: true }));
    if (finalData?.active_modules[0] === '') finalData.active_modules = [];

    if (!(hasLength && hasLowercase && hasUppercase && hasNumber) && password)
      return error('Password type errors');

    if (password !== confirm_password)
      return error('Confirm new password does not match');
    try {
      PUT(`/api/users/${slug || user_id}/update/`, removeNullFields(finalData))
        .then((res) => {
          if (res.status === 200) {
            successNotification('Data changed successfully.');
            password && formik.setFieldValue('password', null);
            confirm_password && formik.setFieldValue('confirm_password', null);
          }
          setTimeout(() => {
            setState((pre) => ({ ...pre, loading: false }));
          }, 1000);
        })
        .catch((err) => {
          const outputObject = Object.fromEntries(
            Object.entries(err?.response?.data).slice(0, 5),
          );
          const divElements = Object.entries(outputObject).map(
            ([key, value]) => {
              if (key === 'personal_email') {
                formik.setFieldError(key, 'Enter a valid email address.');
              } else {
                formik.setFieldError(
                  key,
                  `${dataKeyUser[key] ? dataKeyUser[key] : key} ${
                    value[0] ? value[0] : 'is required'
                  }`,
                );
              }

              return (
                <div
                  style={{ color: '#E02C2C', fontWeight: 400, fontSize: 14 }}
                  key={key}
                >
                  {`"${dataKeyUser[key] ? dataKeyUser[key] : key}"`}
                  {key === 'personal_email' ||
                  key === 'linkedin' ||
                  key === 'viadeo' ||
                  key === 'twitter' ||
                  key === 'facebook'
                    ? ' is invalid'
                    : ' is mandatory'}
                </div>
              );
            },
          );
          setTimeout(() => {
            setState((pre) => ({ ...pre, loading: false }));
          }, 1000);
          error('Missing or incorrect information', divElements);
        });
    } catch (error) {
      error('Something went wrong');
      setTimeout(() => {
        setState((pre) => ({ ...pre, loading: false }));
      }, 1000);
    }
  };

  const onUpdateData = useCallback((data: object) => {
    setUpdateData(Object.assign(updateData, data));
  }, []);
  const timeOut = () => {
    setState((pre) => ({ ...pre, loading: false }));
  };

  const handleChangeTabNumber = (value: number) => {
    if (value !== numberTab) setNumberTab(value);
    let width = 0;
    Array.from(containerRef.current?.children || []).forEach((item, index) => {
      if (index < value) {
        width += item.clientWidth + 20;
      }
    });
    setWidthTransition(width);
    const positionItem = document.getElementById(`part-${value + 1}`);
    positionItem.scrollIntoView({
      behavior: 'smooth',
    });
  };
  useEffect(() => {
    const userData = data?.data;

    setState((pre) => ({
      ...pre,
      userData,
    }));
    if (data)
      formik.resetForm({
        values: userData,
      });
    setUpdateData({
      ...userData,
    });
    getCountries().then((res) => {
      setState((pre) => ({
        ...pre,
        nationality: getNationality(),
        countries: res?.data?.data?.map((item) => {
          return {
            label: item.country,
            value: item.country,
          };
        }),
      }));
    });
    setTimeout(timeOut, 2000);
  }, [data]);

  useEffect(() => {
    refetch();
  }, [user_id]);

  if (loading || status === 'loading') return <Loading />;
  return (
    <form onSubmit={formik.handleSubmit}>
      <GeneralHeader
        pageTitle="Personal Data"
        icon="/icons/personal-avatar.png"
        btnComponent={
          user.role === 'admin' && (
            <button
              type="submit"
              style={{
                width: 'fit-content',
                height: 40,
                padding: '8px 12px',
                background: !formik.dirty && '#E4E4E4',
                border: !formik.dirty && 'transparent',
              }}
              className="header-button"
              disabled={!formik.dirty || user.role !== 'admin'}
            >
              <img src="/icons/save_button_v2.svg" alt="button" />
              <span> SAVE</span>
            </button>
          )
        }
        child={
          <div style={{ paddingBottom: 70 }}>
            {/* {user?.role === 'admin' && ( */}
            <div>
              <h2
                style={{
                  marginTop: 50,
                  fontWeight: 700,
                  textAlign: 'center',
                  fontSize: 32,
                  color: 'black',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {formik.values?.first_name + ' ' + formik.values?.last_name}
              </h2>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  marginTop: 40,
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 20,
                    color: '#757575',
                    display: 'flex',
                    alignSelf: 'end',
                    gap: '20px',
                    position: 'relative',
                  }}
                  ref={containerRef}
                >
                  {listOptionsPersonal.map((item) => (
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '0 5px',
                        color: item.value === numberTab && '#0E3063',
                      }}
                      key={item.value}
                      onClick={() => handleChangeTabNumber(item.value)}
                    >
                      {item.name}
                    </div>
                  ))}
                  <div
                    style={{
                      position: 'absolute',
                      height: 2,
                      bottom: -15,
                      background: '#0E3063',
                      transition: 'all 300ms ease-in-out',
                      width: ItemWidth,
                      transform: `translateX(${widthTransition}px)`,
                    }}
                  />
                </div>
              </div>
            </div>
            {/* )} */}
            <div style={{ width: '100%', marginTop: 40 }} id="anchor"></div>
            <div style={{ marginTop: '40px' }} className={'fourth_step'}>
              <div>
                <h1
                  id="part-1"
                  style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    color: '#000000',
                    paddingBottom: '30px',
                  }}
                >
                  Personal Data
                </h1>
                <div className="add_user_first_step_creation_type">
                  <PersonalInfo
                    onUpdateData={onUpdateData}
                    userData={data?.data}
                    formik={formik}
                  />
                </div>
                <div
                  style={{ marginTop: 32 }}
                  className="add_user_first_step_creation_type"
                >
                  <CivilStatus
                    onUpdateData={onUpdateData}
                    user={data?.data}
                    nationality={nationality}
                    countries={countries}
                    formik={formik}
                  />
                </div>
                <div id="part-2">
                  <h1
                    style={{
                      fontWeight: 600,
                      fontSize: '24px',
                      padding: '30px 0',
                      color: '#000000',
                    }}
                  >
                    Staffing
                  </h1>
                </div>
                <div className="add_user_first_step_creation_type">
                  <StaffInfo
                    onUpdateData={onUpdateData}
                    user={data?.data}
                    formik={formik}
                  />
                </div>
                <div
                  style={{ marginTop: 32 }}
                  className="add_user_first_step_creation_type"
                >
                  <WorkingDays
                    role={user?.role}
                    onUpdateData={onUpdateData}
                    user={data?.data}
                    countries={countries}
                    formik={formik}
                  />
                </div>

                <h1
                  id="part-3"
                  style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    padding: '30px 0',
                    color: '#000',
                  }}
                >
                  Rules
                </h1>
                <div className="add_user_first_step_creation_type">
                  <Rules
                    onUpdateData={onUpdateData}
                    user={data?.data}
                    formik={formik}
                  />
                </div>
                {/* <div
                style={{ marginTop: 32 }}
                className="add_user_first_step_creation_type"
              >
                <TimeSheet />
              </div> */}
                <h1
                  id="part-4"
                  style={{
                    fontWeight: 600,
                    fontSize: '24px',
                    padding: '30px 0',
                    color: '#000000',
                  }}
                >
                  Admin
                </h1>
                <div className="add_user_first_step_creation_type">
                  <AdminInfo user={data?.data} formik={formik} />
                </div>
                {/* <div
                  id="part-5"
                  style={{ marginTop: 32 }}
                  className="add_user_first_step_creation_type"
                >
                  <TehnicalInfo />
                </div> */}
                {/* <h1 style={{ fontWeight: 600, fontSize: '24px', marginTop: 10 }}>
                Preferences
              </h1>
              <div
                style={{ marginTop: 32 }}
                className="add_user_first_step_creation_type"
              >
                <DisplaySettings />
              </div> */}
                {/* <div style={{ marginBottom: 32 }}>
                <DelegatedRequest />
              </div> */}
              </div>
            </div>
          </div>
        }
      />
      {/* )} */}
    </form>
  );
};

export default PersonalData;
